export interface ChartAndStats {
  stats: Stats;
  withCashSeries: DepotChartSerie[];
  withoutCashSeries: DepotChartSerie[];
}

export interface Stats {
  cashTotal: number;
  cashPayInTotal: number;
  cashPayOutTotal: number;
  portfolioTransferTotal: number;
  performancePercentage: number;
}

export interface DepotChartSerie {
  date: string;
  total: number;
}

export enum Period {
  THREE_MONTHS = 'THREE_MONTHS',
  ONE_YEAR = 'ONE_YEAR',
  MAX = 'MAX',
}

export interface ChartPeriodDates {
  from: Date;
  to: Date;
}
